import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { catchError, Observable, of } from 'rxjs';
import { ISnackBarData, SnackBarComponent } from '@lyra/app/shared/components/snack-bar/snack-bar.component';

import { RouteString } from '../enums/route-string';
import { ERROR } from '../store/actions/error.actions';
import { LanguagesSelectService } from '../store/selectors/languages.selector';
import { SSRService } from './ssr.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private _errorCode: any;
  private _selectedLanguage: Signal<string>;
  constructor(
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _languagesSelect: LanguagesSelectService,
    private _SSRService: SSRService,
  ) {
    this._selectedLanguage = toSignal(this._languagesSelect.getSelectedCode(), {
      initialValue: 'en',
    });
  }

  handleApiError(response: any, name: string, error: any = ERROR({ error: response.error })): Observable<any> {
    console.error(name, response);
    // let message =
    //   response.Error?.ErrorMessage ||
    //   response.Error?.Title ||
    //   response.Error?.Message ||
    //   response.Message ||
    //   response.Code ||
    //   'Unknown Error';
    // if (response.status === 500) {
    //   message = 'Server Error';
    // }

    // this._router.navigate(['.', this._selectedLanguage(), RouteString.ERROR], {
    //   relativeTo: this._activatedRoute,
    //   queryParamsHandling: 'merge',
    // });
    if (this._SSRService.isBrowserOnly) {
      this._snackBar.openFromComponent(SnackBarComponent, {
        data: {
          text: 'Oops! Something went wrong. Please try again.',
          closeButton: true,
          icon: { name: 'info' },
          action: 'error',
        } as ISnackBarData,
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['mark-snackbar', 'error'],
      });
      window.MarkBhFinal.error?.next();
    }
    return of(error);
  }

  effectError<T>(name: string) {
    return (source: Observable<T>): Observable<ReturnType<typeof ERROR>> => {
      return source.pipe(catchError((response) => this.handleApiError(response, name)));
    };
  }
}
